/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StatusBadge from './StatusBadge.vue';
import DialogComponent from 'shared/ui/components/modals/DialogComponent.vue';
import ModalForm from 'shared/ui/components/form-components/ModalForm.vue';
import RejectModal from 'ui/components/meetings/meeting-requests/RejectModal.vue';

const __vue_script__ = {
    name: 'StatusSection',
    components: {
        StatusBadge,
        ModalForm,
        RejectModal
    },
    props: {
        value: {
            type: String,
            default: null
        },

        edit: {
            type: Boolean,
            default: false
        },

        event: {
            type: Object,
            default: () => ({})
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            parentModel: {},
            actionButtons: [],
            showActions: false,
            descriptionLines: [],
            showDescription: false,
            totalParticipantCount: 0,
            pendingParticipantCount: 0,
            loading: false,
            statusTime: {}
        };
    },

    watch: {
        '$attrs.model': {
            deep: true,
            immediate: true,
            handler() {
                this.checkDisabled();
                this.populateData();
            }
        },
        actionButtons(newButtons) {
            this.showActions = newButtons?.length > 0;
        },
        descriptionLines(newLines) {
            this.showDescription = newLines?.length > 0;
        },
    },

    created() {
        this.checkDisabled();
        this.populateData();

        this.$on('request-availability', this.onRequestAvailability);
        this.$on('reject-request', this.onRejectRequest);
        this.$on('schedule-meeting', this.onScheduleMeeting);
        this.$on('meeting-request-scheduled', this.onMeetingScheduled);
    },

    beforeDestroy() {
        this.$off('request-availability', this.onRequestAvailability);
        this.$off('reject-request', this.onRejectRequest);
        this.$off('schedule-meeting', this.onScheduleMeeting);
        this.$off('meeting-request-scheduled', this.onMeetingScheduled);
    },

    methods: {
        /**
         * Update the current data of the component based on the parentModel
         */
        populateData() {
            this.parentModel = this.$attrs.model;
            this.totalParticipantCount = this.parentModel.participants?.length || 0;
            this.pendingParticipantCount = this.parentModel.participants?.
                filter(p => !p.availability).length || 0;
            const containsMissingEmails = (this.parentModel.participants || []).some(
                ({ missing_email }) => missing_email
            );

            switch (this.value) {
                case 'draft':
                    this.actionButtons = [{
                        key: 'request-availability',
                        disabled: this.pendingParticipantCount === 0 || containsMissingEmails,
                        isPrimary: true
                    }];
                    this.descriptionLines = [
                        'meetings.requests.status.section.description.draft_line1',
                        'meetings.requests.status.section.description.draft_line2',
                        'meetings.requests.status.section.description.draft_line3'
                    ];
                    this.statusTime = {};
                    break;
                case 'awaiting':
                case 'ready':
                    this.actionButtons = [
                        {
                            key: 'reject-request',
                            disabled: containsMissingEmails,
                            isPrimary: false
                        }, {
                            key: 'schedule-meeting',
                            disabled: !this.parentModel.timeslot || containsMissingEmails,
                            isPrimary: true
                        }
                    ];
                    this.descriptionLines = [
                        'meetings.requests.status.section.description.awaiting',
                    ];
                    this.statusTime = this.parentModel.invitation_sent_timestamp ?
                        {
                            label: 'meetings.requests.status.section.email_sent_time',
                            value: this.$utils.time.tsToFormat(this.parentModel.invitation_sent_timestamp, 'LLL')

                        } : {};
                    break;
                case 'confirmed':
                    this.actionButtons = [];
                    this.descriptionLines = [];
                    this.statusTime = this.parentModel.meeting_scheduled_timestamp ?
                        {
                            label: 'meetings.requests.status.section.meeting_scheduled_time',
                            value: this.$utils.time.tsToFormat(this.parentModel.meeting_scheduled_timestamp, 'LLL')
                        } : {};
                    break;
                case 'rejected':
                    this.actionButtons = [];
                    this.descriptionLines = [];
                    this.statusTime = this.parentModel.rejected_timestamp ?
                        {
                            label: 'meetings.requests.status.section.rejected_time',
                            value: this.$utils.time.tsToFormat(this.parentModel.rejected_timestamp, 'LLL')
                        } : {};
                    break;
                default:
                    this.actionButtons = [];
                    this.descriptionLines = [];
                    this.subheader = {};
                    break;
            }
        },

        /**
         * Request availability action handler
         * Show dialog to confirm sending availability emails
         * and calls related method to send emails if confirmed
         */
        checkDisabled() {
            if (['confirmed', 'rejected'].includes(this.value)) {
                this.$emit('disable', true);
            }
        },

        /**
         * Request availability action handler
         * Show dialog to confirm sending availability emails
         * and calls related method to send emails if confirmed
         */
        onRequestAvailability() {
            this.$modal.show(DialogComponent, {
                title: this.$t('meetings.requests.dialog.request-availability.title'),
                text: this.$t('meetings.requests.dialog.request-availability.text'),
                buttons: [{
                    title: this.$t('general.cancel'),
                    handler: () => this.$modal.hide('meeting-request-availability'),
                    class: 'btn'
                }, {
                    title: this.$t('meetings.requests.dialog.request-availability.send'),
                    default: true,
                    handler: async () => {
                        if (this.loading) {
                            return;
                        }
                        this.loading = true;

                        if (!this.parentModel._id) {
                            await this.saveAndRequestAvailability();
                        } else {
                            await this.sendAvailabilityEmails();
                            this.$notify({
                                group: 'flashes',
                                text: this.$i18n.t('meetings.requests.notify.availability_request_sent_success').toString(),
                            });
                            this.$emit('reload');
                        }

                        this.$modal.hide('meeting-request-availability');
                        this.loading = false;
                    },
                    class: 'btn btn-primary'
                }],
            }, {
                name: 'meeting-request-availability',
                classes: 'small',
                reset: true,
                height: 'auto'
            });
        },

        /**
         * Reject request action handler
         * Show dialog to confirm rejection of meeting request
         * and calls rejection handler if confirmed
         */
        onRejectRequest() {
            this.$modal.show(RejectModal, {
                ids: [this.parentModel._id],
                event: this.event,
                onClose: () => {
                    this.$modal.hide('meeting-request-reject');
                    this.$emit('reload');
                }
            }, {
                name: 'meeting-request-reject',
                classes: 'small',
                reset: true,
                height: 'auto'
            });
        },

        /**
         * Schedule meeting action handler
         * Show pre-filled modal form to create a meeting
         * In case of meeting creation, call related method to update
         * meeting request status
         */
        onScheduleMeeting() {
            const start_ts = this.$utils.time.dateToUnix(this.parentModel.timeslot);
            const participants = this.parentModel.participants.filter(
                p => !p.availability || (p.availability && p.availability.some(
                    a => a.start === this.parentModel.timeslot
                ))
            );
            const meetingModel = {
                title: this.parentModel.title,
                description: this.parentModel.description,
                start_ts,
                duration: this.parentModel.duration,
                participants,
                organizer: this.parentModel.representative,
                __event: this.event
            };

            this.$modal.show(ModalForm, {
                title: this.$t('listings.actions.new_meeting'),
                event: this.event,
                model: meetingModel,
                fpType: 'meeting',
                onSave: () => {
                    this.onMeetingScheduled();
                },
                onClose: this.onEditorClosed,
                onError: () => console.log('Error scheduling meeting'),
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        /**
         * Post processing of meeting request scheduling
         * Calls related app script to process meeting request scheduling
         * in the pkg-meetings
         */
        async onMeetingScheduled() {
            try {
                await this.$services.appScripts.callAppScript(
                    this.event._id,
                    'meeting-requests/meeting-scheduled',
                    { id: this.parentModel._id }
                );
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.requests.notify.meeting_created_success').toString(),
                });
                await this.$emit('reload');
            } catch (error) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.requests.notify.meeting_created_fail').toString(),
                    type: 'error'
                });
            }
        },

        /**
         * Save and request availability handler
         * Calls related method to save the current form and
         * send availability emails to participants after saved
         */
        async saveAndRequestAvailability() {
            this.$emit('behaviour', {
                afterSave: async () => {
                    // wait for MetaFieldset value watcher to set _id
                    await this.$nextTick();

                    const id = this.parentModel._id;
                    await this.sendAvailabilityEmails();
                    this.$router.push(
                        this.generateRedirectUrlToEditView(this.event._id, id)
                    );
                    this.$notify({
                        group: 'flashes',
                        text: this.$i18n.t('meetings.requests.notify.saved_and_availability_request_sent').toString(),
                    });
                }
            });
            this.$emit('save', { preventRedirect: true });
        },

        generateRedirectUrlToEditView(eventId, modelId) {
            const moduleConfig = this.$services.blueprint.getModuleByName('meetings');
            const route = moduleConfig.controllers['edit-request'].route;
            return route.replace(':eventId', eventId).replace(':modelId', modelId);
        },

        /**
         * Send availability emails handler
         * Calls related app script to send availability emails
         * to participants of the meeting request
         */
        async sendAvailabilityEmails() {
            try {
                await this.$services.appScripts.callAppScript(
                    this.event._id,
                    'meeting-requests/request-availability',
                    { ids: [this.parentModel._id] }
                );
            } catch (error) {
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('meetings.requests.notify.availability_request_sent_fail').toString(),
                    type: 'error'
                });
            }
        },

        /**
         * Process meeting request rejection
         * Calls related app script to process meeting request rejection
         * in the pkg-meetings
         * @param notify boolean flag to send email to participants
         */
        async processMeetingRequestRejection({ notify }) {
            await this.$services.appScripts.callAppScript(
                this.event._id,
                'meeting-requests/reject-request',
                { ids: [this.parentModel._id], notify }
            );
            await this.$emit('reload');
        },
    }
};


/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "meeting-request-status-section" }, [
    _c(
      "div",
      { staticClass: "status-header" },
      [
        _c("h5", [
          _vm._v(_vm._s(_vm.$t("meetings.requests.status.section.title"))),
        ]),
        _c("status-badge", {
          attrs: {
            status: _vm.value,
            "total-participant-count": _vm.totalParticipantCount,
            "pending-participant-count": _vm.pendingParticipantCount,
          },
        }),
      ],
      1
    ),
    _vm.statusTime && _vm.statusTime.value
      ? _c("div", { staticClass: "status-timestamp" }, [
          _c("span", { staticClass: "label" }, [
            _vm._v(_vm._s(_vm.$t(_vm.statusTime.label))),
          ]),
          _c("span", { staticClass: "value" }, [
            _vm._v(" " + _vm._s(_vm.statusTime.value)),
          ]),
        ])
      : _vm._e(),
    _vm.showDescription || _vm.showActions ? _c("hr") : _vm._e(),
    _vm.showDescription
      ? _c(
          "div",
          { staticClass: "description" },
          _vm._l(_vm.descriptionLines, function (line) {
            return _c("p", [_vm._v(_vm._s(_vm.$t(line)))])
          }),
          0
        )
      : _vm._e(),
    _vm.showActions
      ? _c(
          "div",
          { staticClass: "actions" },
          _vm._l(_vm.actionButtons, function (action) {
            return _c(
              "button",
              {
                key: action.key,
                staticClass: "btn important",
                class: { primary: action.isPrimary },
                attrs: { type: "button", disabled: action.disabled },
                on: {
                  click: function ($event) {
                    return _vm.$emit(action.key)
                  },
                },
              },
              [
                _vm._v(
                  _vm._s(_vm.$t("meetings.requests.actions." + action.key))
                ),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/meeting-requests/StatusSection.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__